import type { ObjectFxKind } from '../../interact/types.js';

export type TownMicroInteractionKind = 'music' | 'library' | 'playground';
export type TownMicroAction = 'happy' | 'jump' | 'sit' | 'wave';

export type TownMicroInteractionPlan = {
  copy: string;
  actions: readonly TownMicroAction[];
  fx: ObjectFxKind;
  propEmoji: string;
};

export const MICRO_INTERACTIONS: Record<
  TownMicroInteractionKind,
  TownMicroInteractionPlan
> = {
  music: {
    copy: 'Bau-bau rytm! 🎵',
    actions: ['wave', 'happy'],
    fx: 'notes',
    propEmoji: '🎶',
  },
  library: {
    copy: 'Czytamy bajkę o smoku! 📖',
    actions: ['sit', 'happy'],
    fx: 'sparkle',
    propEmoji: '📖',
  },
  playground: {
    copy: 'Jeszcze raz na zjeżdżalni! 🛝',
    actions: ['jump', 'jump'],
    fx: 'stars',
    propEmoji: '💨',
  },
};

const SCENE_TO_KIND: Readonly<Record<string, TownMicroInteractionKind>> = {
  Music: 'music',
  Library: 'library',
  Playground: 'playground',
};

export function microInteractionForScene(
  sceneKey: string,
): TownMicroInteractionPlan | null {
  const kind = SCENE_TO_KIND[sceneKey];
  return kind ? MICRO_INTERACTIONS[kind] : null;
}
